export {default as editable} from './main/editable'
export type {EditableState, BindFunction} from './main/store'
/**
 * This is a private API that's exported so that `@theatre/r3f/dist/extension`
 * and `@theatre/r3f` can talk to one another. This API _could_ change
 * between patch releases, so please don't build on it :)
 *
 * @internal
 */
export {
  editorStore as ____private_editorStore,
  allRegisteredObjects as __private_allRegisteredObjects,
} from './main/store'
/**
 * This is a private API that's exported so that `@theatre/r3f/dist/extension`
 * and `@theatre/r3f` can talk to one another. This API _could_ change
 * between patch releases, so please don't build on it :)
 *
 * @internal
 */
export {makeStoreKey as __private_makeStoreKey} from './main/utils'

export {default as SheetProvider, useCurrentSheet} from './main/SheetProvider'
export {
  default as RafDriverProvider,
  useCurrentRafDriver,
} from './main/RafDriverProvider'
export {refreshSnapshot} from './main/utils'
export {default as RefreshSnapshot} from './main/RefreshSnapshot'
export * from './drei'
